import * as Sentry from '@sentry/react';
import { isLookupNotFoundError } from './lookupHelpers';

type RunLookupRequestParams<TLookupResponse> = {
  isEnabled: boolean;
  clearValues: () => void;
  beginRequest: () => void;
  endRequest: () => void;
  markNotFound: () => void;
  markRequestError: () => void;
  fetchLookup: () => Promise<TLookupResponse>;
  onSuccess: (response: TLookupResponse) => void;
  onBeforeFetch?: () => void;
};

export const runLookupRequest = <TLookupResponse>({
  isEnabled,
  clearValues,
  beginRequest,
  endRequest,
  markNotFound,
  markRequestError,
  fetchLookup,
  onSuccess,
  onBeforeFetch
}: RunLookupRequestParams<TLookupResponse>) => {
  if (!isEnabled) {
    return;
  }

  void (async () => {
    try {
      clearValues();
      beginRequest();
      onBeforeFetch?.();

      const response = await fetchLookup();
      onSuccess(response);
    } catch (error: any) {
      console.log(error);
      if (isLookupNotFoundError(error)) {
        markNotFound();
      } else {
        Sentry.captureException(error);
        markRequestError();
      }
    } finally {
      endRequest();
    }
  })();
};
